/**
 * Klaviyo Back in Stock – variant-based button visibility
 * Listens for variant:change on product forms and toggles Add to Cart vs Back in Stock button.
 */
(function () {
  const HIDDEN_CLASS = 'buy-buttons__button--hidden';

  function toggleButtons(form, variant) {
    const atcWrapper = form.querySelector('[data-buy-button="atc"]');
    const bisWrapper = form.querySelector('[data-buy-button="bis"]');

    if (!atcWrapper || !bisWrapper) return;

    const available = variant && variant.available;

    if (available) {
      atcWrapper.classList.remove(HIDDEN_CLASS);
      bisWrapper.classList.add(HIDDEN_CLASS);
    } else {
      atcWrapper.classList.add(HIDDEN_CLASS);
      bisWrapper.classList.remove(HIDDEN_CLASS);
    }
  }

  function init() {
    document.querySelectorAll('buy-buttons[form]').forEach(function (buyButtonsEl) {
      const formId = buyButtonsEl.getAttribute('form');
      if (!formId) return;
      const form = document.getElementById(formId);
      if (!form || form.hasAttribute('data-bis-variant-listener')) return;

      form.setAttribute('data-bis-variant-listener', 'true');

      form.addEventListener('variant:change', function (event) {
        const variant = event.detail && event.detail.variant;
        toggleButtons(form, variant);
      });
    });
  }

  /**
   * Sticky add to cart: when "Sold out" is clicked, trigger the Klaviyo back-in-stock button
   */
  function triggerKlaviyoBis() {
    var klaviyoTrigger = document.querySelector('#klaviyo-bis-button-container button');
    if (klaviyoTrigger) {
      klaviyoTrigger.click();
      return;
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest('.product-sticky-add-to-cart__bis-trigger')) {
      e.preventDefault();
      triggerKlaviyoBis();
    }
    if (e.target && e.target.closest('.klaviyo-custom-trigger')) {
      e.preventDefault();
      triggerKlaviyoBis();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify theme editor or sections re-render (e.g. product:rerender replaces buy-buttons)
  document.addEventListener('shopify:section:load', init);
})();
